<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl relative">
        Cykle fakturowania
    </h1>

    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">Nazwa</th>
          <th class="px-6 pt-6 pb-4">Domyślny</th>
        </tr>
        <tr v-for="cycle in cycles" :key="cycle.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <span class="px-6 py-4 flex items-center focus:text-shtax-500">
              {{ cycle.name }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-6 py-4 flex items-center focus:text-shtax-500">
              {{ cycle.default ? 'Tak' : 'Nie' }}
            </span>
          </td>
        </tr>
        <tr v-if="cycles.length === 0">
          <td class="border-t px-6 py-4" colspan="4">Brak cykli fakturowania.</td>
        </tr>
      </table>
    </div>

  </div>
</template>

<script>
import Layout from '@/Shared/Layout'

export default {
  metaInfo: { title: 'Cykle fakturowania' },
  components: {
  },
  layout: Layout,
  props: {
    cycles: Array
  },
  data() {
    return {
    }
  }
}
</script>
